import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { APP_CONFIG } from '@config';

/**
 * Hook para actualizar el título del documento según la ruta actual
 * Útil para rutas guest que no tienen acceso al NavigationProvider
 */
export function useDocumentTitle() {
  const location = useLocation();
  const { t: tAuth, i18n } = useTranslation('auth');
  const { t: tUi } = useTranslation('ui');

  useEffect(() => {
    // Mapeo de rutas guest a títulos traducidos
    const guestRouteTitles: Record<string, string> = {
      '/login': tAuth('login.title', 'Iniciar Sesión'),
    };

    // Buscar título para la ruta actual
    const routeTitle = guestRouteTitles[location.pathname];

    if (routeTitle) {
      document.title = `${routeTitle} - ${APP_CONFIG.appName}`;
    } else {
      // Título por defecto si no hay match
      document.title = APP_CONFIG.appName;
    }
  }, [location.pathname, tAuth, tUi, i18n.language]);
}

